import { renderIcon } from '../../SvgIcon.esm.js';

/******************************************************
 * This file was created by scripts/generate.js as part
 * of the build process. Do not edit this file directly.
 ******************************************************/
var iconType = {
  viewBox: "0 0 24 24",
  paths: [{
    d: "M14.474 12.5104c0 1.2037-.2518 2.2758-.7553 3.2162-.5034.9404-1.221 1.6753-2.1527 2.2048-.9317.5295-1.9994.7943-3.2032.7943-.8622 0-1.6869-.1678-2.474-.5035-.787-.3356-1.464-.787-2.0312-1.3541-.567-.5672-1.0185-1.2443-1.3541-2.0313C2.1678 14.0498 2 13.2251 2 12.3628c0-.8622.1678-1.6869.5035-2.474.3356-.787.787-1.464 1.3541-2.0312.5672-.567 1.2443-1.0185 2.0313-1.3541C6.6759 6.1678 7.5006 6 8.3629 6c1.655 0 3.0758.5556 4.2621 1.6667l-1.7274 1.658c-.6771-.654-1.522-.981-2.5348-.981-.7118 0-1.37.1794-1.9748.5382-.6047.3588-1.0836.8464-1.4366 1.4627-.353.6163-.5295 1.289-.5295 2.0182 0 .7292.1765 1.402.5295 2.0183.353.6163.8319 1.1039 1.4366 1.4627.6048.3587 1.263.5381 1.9748.5381.4804 0 .9216-.0665 1.3238-.1996.4022-.1331.7335-.2995.994-.4991a3.6183 3.6183 0 00.6814-.6815c.1938-.2546.3356-.4948.4253-.7204.0897-.2257.152-.4399.1867-.6424H8.3628v-2.1875h6.007c.0694.3646.1042.7176.1042 1.059zM22 11.4514v1.823h-1.8142v1.8141h-1.823v-1.8142h-1.8142v-1.823h1.8142V9.6373h1.823v1.8142H22z",
    fillRule: "evenodd"
  }],
  circles: []
};
var GooglePlusIcon = function GooglePlusIcon(props) {
  return renderIcon(props, iconType);
};
export { GooglePlusIcon };